/**
 * 메뉴바/툴바 관련 UI 문자열 리소스
 * main-toolbar, main-tab 등에서 사용
 */
export const menuBarStr = {
  error: {
    /** 씨드 출자액 0 오류 */
    seedAmountZero: '씨드 출자액을 입력해주세요.',
    cannotContributeMoreThanReserved: '투자 유보액보다 많이 출자할 수 없습니다.',
    cannotWithdrawMoreThanAvailable: '{type} 금액보다 많이 회수할 수 없습니다.',
    notRunning: '투자 실행 중이 아닙니다.',
    noWithdrawableProfit: '회수 가능한 수익이 0입니다.',
    withdrawAmountInvalid: '회수 금액이 0 이하입니다.',
    cannotWithdrawMoreThanProfit: '회수 가능한 금액보다 많이 회수할 수 없습니다.',
    selectExchange: '거래소를 선택해 주세요.',
    endTimeMustBeAfterStart: ' 종료 시간은 시작 시간보다 커야 합니다.',
    virtualBalanceMin: '가상 잔고는 {min} 이상이어야 합니다.',
  },
  toolbar: {
    selectSymbol: '종목 선택',
    strategy: '전략 선택',
    timeframeSetting: '{name} 설정',
    exchange: '거래소',
    marginMode: '마진 모드',
    leverage: '레버리지',
    balance: '잔고',
    loadBalance: '잔고 불러오기',
    reserved: '투자 유보 금액',
    seed: '씨드 출자',
    seedWithdraw: '씨드 회수',
    profitWithdraw: '수익 회수',
    evalSeed: '평가',
    contribution: '출자',
    evalProfit: '평가 순익',
    profitRate: '순익률',
    goalAchieve: '목표 달성',
    investable: '진입 가능(미진입 잔고 - 투자 유보액)',
    profitTarget: '순익 목표',
    stopLoss: '손절액',
    investMode: '투자 모드',
    startTime: '시작 시간',
    endTime: '종료 시간',
    investablePercent: '진입 가능액({amount})의',
    percentAmount: '{percent}% - {amount}',
  },
  label: {
    wallet: '지갑',
    holding: '보유',
    reserved: '투자 유보',
    contribution: '출자',
    evaluation: '평가',
    seed: '씨드',
    withdraw: '회수',
    contribute: '출자',
    profit: '순익',
    profitRate: '률',
    goal: '목표',
    achievement: '달성',
    investable: '진입 가능',
    strategySave: '저장',
    amountInput: '금액 입력',
  },
  button: {
    startBot: '봇 시작',
    stopBot: '봇 중지',
    start: '시작',
    stop: '중지',
    saveAndChange: '저장 후 변경',
    saveAsAndChange: '새 이름으로 저장 후 변경',
    changeWithoutSave: '저장하지 않고 변경',
    noChange: '변경 안 함',
    confirm: '확인',
    cancel: '중지',
  },
  dropdown: {
    reservedOf: '투자 유보액({amount})의',
    investableOf: '진입 가능액({amount})의',
    withdrawableProfitOf: '회수 가능 수익({amount})의',
  },
  menu: {
    save: '저장',
    saveAs: '새 이름으로 저장',
  },
  message: {
    dataGenComplete: '투자 체크 종목 필요 지표 및 자료 생성이 완료 되었습니다.',
    backtestComplete: '백테스트가 완료되었습니다.',
    cannotChangeTimeframe: '투자 실행 중에는 타임프레임 설정을 변경할 수 없습니다. 중지 후 재시도해주세요.',
    noWithdrawableProfit: '회수 가능한 수익 없음',
    currentStrategy: '현재 선택된 전략',
    changeStrategy: '전략 변경',
    backtestStartTimeRequired: '백테스트 시작 시간을 선택해 주세요.',
    withdrawComplete: '{amount} 회수 완료',
    stopFailed: '중지 실패',
    confirmStopWithExit: '모든 포지션들을 종료 후 중지합니다. 계속 하시겠습니까?',
    positionExitFailed: '다음 종목들의 포지션 청산이 실패하였습니다. 거래소에서 직접 청산하여 주세요.\n{symbols}',
    unsavedChanges: '{strategy}의 변경 사항이 저장되지 않았습니다. 어떻게 하시겠습니까?',
  },
  loading: {
    marketChanging: '종목 변경 중입니다. 잠시 기다려 주세요...',
    stopping: '중지 중입니다. 잠시 기다려 주세요...',
    generatingSignals: '{backtest}종목들의 거래신호 처리 및 매매내역 생성 중입니다...',
    autoExiting: '포지션 자동 청산 중입니다. 잠시 기다려 주세요...',
    backtest: '백테스트 ',
  },
  modal: {
    autoSplitEntry: '자동 분할 진입',
  },
  mainTab: {
    confirmTabChange: '탭 변경을 위해서 투자를 중지합니다. 계속 하시겠습니까?',
    confirmTabChangeWithExit: '탭 변경을 위해서 모든 포지션들을 청산 후 투자를 중지합니다. 계속 하시겠습니까?',
    seedEvalZero: '씨드 평가액이 0입니다. [씨드 출자] 기능으로 씨드를 추가 충전해주세요.',
    darkModeToggle: '다크모드 토글',
    refresh: '새로고침',
    settings: '환경설정',
  },
  timeframesEditor: {
    title: '{title} 설정',
    strategyUpdated: '{name} 전략이 업데이트되었습니다.',
  },
  marketTicker: {
    viewChart: '{symbol} 차트 보기',
    highLow: 'H/L',
    change: '변동',
    volume: '거래량',
  },
};
